var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E51F9A0B-70C2-403C-92C4-F7B38F5D2653") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#666666",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#666666",
    x: 0.5,
    y: 5.5,
    width: 12,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#666666",
    x: 0,
    y: 10,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#666666",
    x: 4.5,
    y: 10,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#666666",
    x: 9,
    y: 10,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#666666",
    x: 13.5,
    y: 10,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#666666",
    x: 18,
    y: 10,
    width: 2,
    height: 2,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletChart);
export default __webpack_public_path__ + "static/media/BulletChart.ca10540fc404f75a4e5a878479e3070b.svg";
export { ForwardRef as ReactComponent };